// extracted by mini-css-extract-plugin
module.exports = {"udtitlesForm":"ParticipantUDTitle_udtitlesForm__32EcH","submitButton":"ParticipantUDTitle_submitButton__3P6j3"};